<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Store {{ item ? `${item.name}` : "" }}</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :parentpage="parentPage" :page="currentPage"/>
          <link-button
            v-if="item"
            :to="{ name: 'orderList', query: { storeId: item.id }}"
            :classes="['btn-info', 'd-block', 'ml-lg-3', 'm-l-15']"
          >
            <i class="mdi mdi-store" />
            Orders
          </link-button>
          <link-button
            v-if="item"
            :to="{ name: 'upload', query: { storeId: item.id }}"
            :classes="['btn-success', 'd-block', 'ml-lg-3', 'm-l-15']"
          >
            <i class="fa fa-plus-circle" />
            Upload
          </link-button>
        </div>
      </div>
    </div>
    <loading-container :loading="loading">
      <div v-if="!item" class="text-center">
        No store found
      </div>
      <div v-else class="row">
        <div class="col-sm-12">
          <div class="card">
             <div class="card-header">
              <h4 class="card-title">General Information</h4>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <tbody>
                  <tr>
                    <td class="font-bold">Store ID</td>
                    <td>
                      <span>{{ item.id }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-bold">Name</td>
                    <td>
                      <span>{{ item.name}}</span>
                    </td>
                  </tr>
                  <tr v-if="currentRole === 'admin'">
                    <td class="font-bold">User</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'userDetail',
                          params: { userId: item.userId }
                        }"
                      >
                        #{{item.userId}}
                      </router-link>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-bold">Type</td>
                    <td>
                      <span>{{ item.type }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-bold">Status</td>
                    <td>
                      <span>{{ item.status }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-bold">Created At</td>
                    <td>
                      <span>{{ item.createdAt | dateDisplay }}</span>
                    </td>
                  </tr>
                  <tr v-if="item.type == 'api'">
                    <td>API keys</td>
                    <td>
                      <div class="table-responsive">
                        <table
                          class="table table-striped dataTable no-footer"
                          style="width: 100%;"
                        >
                          <thead>
                          <tr>
                            <th>KEY</th>
                            <th>GENERATED AT</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="apiKey in item.apiKeys" :key="apiKey.id">
                            <td>{{apiKey.apiKey}}</td>
                            <td>{{apiKey.createdAt | dateDisplay}}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <platfox-configuration :store="item" v-if="item.type === 'platfox'" />
          <amazon-seller-central-configuration :store="item" v-if="item.type === 'amazon_seller_central'" />
        </div>
      </div>
    </loading-container>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import _ from 'lodash'

  import LoadingContainer from "@/components/Misc/LoadingContainer";
  import Breadcrumb from "@/components/Common/Breadcrumb";
  import LinkButton from "@/components/Misc/LinkButton";

  import PlatfoxConfiguration from './Configuration/Platfox';
  import AmazonSellerCentralConfiguration from './Configuration/AmazonSellerCentral';

  export default {
    name: "StoreDetail",
    components: {
      LoadingContainer,
      Breadcrumb,
      PlatfoxConfiguration,
      AmazonSellerCentralConfiguration,
      LinkButton,
    },
    beforeMount() {
      const storeId = this.$route.params.storeId;
      this.getStoreById(storeId);
    },
    computed: {
      ...mapGetters({
        user: "auth/user",
        item: "store/item",
        loading: "store/loading",
      }),
      routeName() {
        return this.$router.name;
      },
      currentPage() {
        return this.$store.state.route.meta.title;
      },
      parentPage() {
        return {
          title: "Store",
          name: "storeList",
        };
      },
      currentUser() {
        return this.user || {};
      },
      currentRole() {
        return this.currentUser.role;
      },
    },
    methods: {
      ...mapActions({
        getStoreById: "store/getStoreById",
      }),
    },

  };
</script>
